export default __webpack_public_path__ + "static/media/klara.78a807d7.jpg";